import moment from 'moment'
import okeResponse from 'okeoke.standardresponse'
import { OrderStatus } from '../consts';
import ordereduuid from '../Helpers/timeuuid'

export default function paymentsProcessor(order, offlineEnabled, clientSocket, client, deviceInfo = null) {
  const findInsertIndexByInsertTimestamp = (array, insertTimestamp) => {
    let index = 0
    try {
      for (let value of array) {
        let isafter = moment(insertTimestamp).isAfter(value.insertTimestamp)
        if (!isafter) break
        index++
      }
    } catch (e) { //Just skip
    }
    return index
  }

  function insertFromCloud(payment, orderObj = null) {
    if (payment == null) return null
    let exists = getPayment('', '', payment.uuid, orderObj)
    if (exists == null) {
      let insertIndex = findInsertIndexByInsertTimestamp(
        orderObj?.payments || order.order.payments,
        payment.insertTimestamp
      )
      if (orderObj) {
        orderObj.payments.splice(insertIndex, 0, payment)
      } else {
        order.order.payments.splice(insertIndex, 0, payment)
      }
      return payment
    } else {
      return null
    }
  }

  function insertPayment(payment) {
    let newPayment = {
      ...payment,
      uuid: ordereduuid(),
      insertTimestamp: new Date().getTime()
    }
    order.addUpdate({ payments: { [newPayment.uuid]: newPayment } })
    return newPayment
  }

  // Add NEW payment
  function addPayment(
    paymentAgentID,
    amount,
    extTransactionID,
    info,
    stornoPaymentUUID,
    agentType = null,
    agentSubType = null
  ) {
    return new Promise((resolve, reject) => {
      if (offlineEnabled) {
        let payment = insertPayment({
          paymentAgentID,
          amount,
          extTransactionID,
          info,
          stornoPaymentUUID,
          agentType,
          agentSubType,
          sysUserUUID: client.localUser?.userUUID || null,
          deviceUUID: deviceInfo?.deviceUUID || null,
          offline: 1
        })
        if (payment != null) {
          order.statuses.addStatus(amount < 0 ? OrderStatus.ORDER_PAYMENT_REFUND : OrderStatus.ORDER_PAYMENT_CONFIRMED, { uuid: payment.uuid })
        }
        resolve(
          payment != null
            ? okeResponse(true, 200, 'OK', payment)
            : okeResponse(false, 403, 'Invalid input', null)
        )
      } else {
        if (clientSocket.authorized) {
          try {
            setTimeout(() => {
              resolve({ success: false, message: 'Timeout!', code: 408, data: { errMsgCode: 'request.error.timeout' } })
            }, 15000)
            clientSocket.ioclient.emit(
              'addPayment',
              {
                orderUUID: order.order.uuid,
                payment: {
                  paymentAgentID,
                  agentType,
                  amount,
                  extTransactionID,
                  info,
                  stornoPaymentUUID,
                  sysUserUUID: client.localUser?.userUUID || null,
                  deviceUUID: deviceInfo?.deviceUUID || null,
                }
              },
              (res) => resolve(res)
            )
          } catch (e) {
            resolve(okeResponse(false, 500, 'Internal error', null))
          }
        } else {
          resolve(okeResponse(false, 503, 'Not connected', {}))
        }
      }
    })
  }

  function getPayment(transactionID = '', paymentAgentID = '', uuid = '', orderObj = null) {
    if (orderObj) {
      for (let payment of orderObj.payments) {
        let match =
          (transactionID !== ''
            ? payment.extTransactionID === transactionID
            : true) &&
          (paymentAgentID !== '' ? payment.paymentAgentID === paymentAgentID : true) &&
          (uuid !== '' ? payment.uuid === uuid : true)
        if (match) return payment // Found
      }
    } else {
      for (let payment of order.order.payments) {
        let match =
          (transactionID !== ''
            ? payment.extTransactionID === transactionID
            : true) &&
          (paymentAgentID !== '' ? payment.paymentAgentID === paymentAgentID : true) &&
          (uuid !== '' ? payment.uuid === uuid : true)
        if (match) return payment // Found
      }
    }
    return null // Not found
  }

  function getPayments(paymentAgentID = '') {
    let payments = []
    for (let payment of order.order.payments) {
      let match =
        paymentAgentID !== '' ? payment.paymentAgentID === paymentAgentID : true
      if (match) payments.push(payment)
    }
    return payments // Not found
  }

  const findStornoForPayment = (paymentUUID) => {
    for (let payment of order.order.payments || []) {
      if (payment?.stornoPaymentUUID === paymentUUID) {
        return payment
      }
    }
    return null
  }

  const transformPayments = (orderPayments) => {
    if (orderPayments == null) return null
    for (let payment of orderPayments) {
      if (payment.stornoPaymentUUID == null) {
        let storno = findStornoForPayment(payment.uuid)
        if (storno != null) {
          payment.deleted = true
        }
      }
    }
  }

  function calculatePaymentsTotal() {
    let sum = 0
    transformPayments(order.order.payments)
    for (let payment of order.order.payments) {
      sum += parseFloat(payment.amount)
    }
    return (sum > 0 ? sum.toFixed() : sum)
  }

  return {
    insertFromCloud,
    addPayment,
    getPayment,
    getPayments,
    calculatePaymentsTotal
  }
}
